export class ReportStatusOUTModel {
  done: boolean
  downloadURL: string
  elapsedTime: number
  error: string
  status: string
  waitingTime: number
}